<template>
  <b-nav>
    <b-nav-item
        class="d-block-custom pr-0"
        to="/home">
      <i class="fa mr-2 fa-home text-black" font-scale="1"></i>Home
    </b-nav-item>
    <b-nav-item
      class="d-block-custom"
      to="/search">
    <i class="fa mr-2 fa-search text-success" font-scale="1"></i>Search
  </b-nav-item>
  </b-nav>
</template>
<script>
export default {
  name: 'top-home-mobility-group'
}
</script>
